module.exports = __webpack_public_path__ + "img/Sam Givhan.7b208d79.jpg";